<template>
  <div class="body-mobile">
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="4"></nav-step>
			</div>
			<div class="wrapper-body__body">
				<div class="wrapper-body__body__title wrapper-title" style="display: flex; justify-content: space-between;">
					<p>报名成功<span>（4/4）</span></p>
				</div>
				<div class="wrapper-body__body__container">
					<div class="bm_info_items" v-if="applyData" id="appData">
						<h2 class="sx-align-center" style="margin-top:.2rem;">资料提交成功</h2>
						<div class="_item"><span>预报名号：</span><font>{{applyData.id}} <i>（请牢记预报名号）</i></font></div>
						<div class="_item"><span>预约日期：</span><font>{{applyData.orderDate}} <i>（{{applyData.amPmTypeName}}{{applyData.beginTime}}-{{applyData.endTime}}）</i></font></div>
						<div class="_item" v-if="studentType === 1"><span>所报幼儿园：</span><font>{{applyData.orderSchoolName}}</font></div>
						<div class="_item" v-else><span>预约街道：</span><font>{{applyData.orderStreetName}}</font></div>
						<div class="_item sub_item" style="margin-top:.25rem;"><span style="font-size:0.32rem;">报名信息：</span>{{studentTypeName}}姓名：{{applyData.name}}</div>
						<div class="_item sub_item"><span></span>{{studentTypeName}}身份证号：<i>{{applyData.idCard}}</i></div>
						<div class="_item sub_item"><span></span>出生日期：{{applyData.birthday}}</div>
						<div class="_item sub_item" v-if="studentType === 2"><span></span>所报年级：{{applyData.orderGradeName}}</div>
						<div class="_item type_item"><span>审核状态：</span><font>{{applyData.statusName}}</font></div>
						<div class="text-error" style="margin:0 .4rem;">
							温馨提示：若未在{{this.studentType === 1 ? '自己预约的' : '规定'}}时间内办理资料审核，请再进入系统“我要查询->修改报名信息”，进行预约时间修改。
						</div>
					</div>
				</div>
			</div>
			<div class="wrapper-body__footer">
				<div class="box-btns" v-if="applyData">
          <span class="button-primary" v-if="applyData && applyData.status === 0  && signData.signupNoticeId===applyData.noticeId" @click="onClickChangeBtn">修改信息</span>
          <span class="button-primary" @click="handleBackHome">返回首页</span>
				</div>
			</div>
		</div>
    <fixed-dialog content=""
        v-if="dialogShow"
        @onClose="dialogShow = false">
        <template :slot="'content'">
          <h2 class="dialog-apply_id" style="color: #f65b55">预报名号：{{applyData.id}}</h2>
          <p style="text-align: center; font-size:16px;">请截屏，或将预报名号抄写在纸上！</p>
        </template>
    </fixed-dialog>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageBmInfo from '../index/mixins/page_bm_info';
  import FixedDialog from './components/FixedDialog.vue'

  export default {
    mixins: [IndexCommon, MobileCommon, PageBmInfo],
    components: { FixedDialog },
    data() {
      return {
        dialogShow: true,
        signData:{}
      }
		},
		async created() {
      let { error, data } = await this.$ajax.gateway('/bm/ISignupNoticeApi_newNoticeProtocol', {
				METHOD: 'get',
        areaId: this.areaId,
        studentType: this.studentType
      });
      this.signData = data.data;
		},
    methods: {
      async onSaveTxt(e){
        this.dialogShow = true
        let applyData = this.applyData;
        // 保存报名号 #吴昂/2020-04-15#
        let {data} = await this.$ajax.gateway("/bm/ITeacherSignupApi_saveSignup", {
            "body": {
                "areaName": applyData.orderStreetName,
                "reservedDate": `${applyData.orderDate} ${applyData.amPmTypeName}${applyData.beginTime}-${applyData.endTime}`,
                "signupId": applyData.id
            }
        });
        let src = data.data;
        let iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = "javascript: '<script>location.href=\"" + src + "\"<\/script>'";
        document.getElementsByTagName('body')[0].appendChild(iframe)
      },
      handleBackHome() {
        console.log(6666666666)
        this.$router.push({ path: '/mobile/login', query: { signupNoticeId: this.signData.signupNoticeId } })
      }     
    }
  }
</script>

<style lang="stylus" scoped>
	.body-mobile
		.wrapper-body
			.wrapper-body__body__container
				padding 0 .1rem;
  .bm_info_items {
		padding-bottom: 20px;
    h2 {
      color #f65b55;
    }
    ._item {
      font-size 32px;
      color #999999;
      line-height 80px;
      span {
        display inline-block;
        width 200px;
        text-align right;
      }
      font {
        color #f65b55;
        font-weight 400;
        i {
          font-weight 100;
          font-style normal;
          font-size 24px;
        }
      }
      &.sub_item {
        line-height 44px;
        font-size 24px;
        color #666;
        span {
          font-size 24px;
          color #999;
        }
      }
      &.type_item {
        font {
          font-weight 400;
          color #39bac0;
        }
      }
    }
    .err_message {
      color #ff0000;
      font-size 20px;
      line-height 36px;
      text-align center;
      padding 120px 0 0;
    }
    .loading_message {
      color #999;
      font-size 12px;
      line-height 24px;
      text-align center;
      padding 140px 0 0;
    }
  }
  .wrapper-title {
    padding: 0 20px;
    text-indent 0;
  }
  .dialog-apply_id {
    text-align center
    font-size 50px;
    font-weight 600;
    & > span {
      color #f00;
    }
  }
</style>
